import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProviderCategories, StateStatus } from '@guryou/redux';
const useAllProviderCategories = () => {
  const dispatch = useDispatch();
  const {
    data,
    status,
    version,
    entity
  } = useSelector(state => state.categories.providersAllCategories);
  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getAllProviderCategories());
    }
  }, [data, dispatch, status]);
  return {
    data: data || [],
    status,
    version,
    entity
  };
};
export default useAllProviderCategories;